import { createContext } from 'react';

import { TimeFormatter } from '../../core/types/formatter.js';

export const TimeseriesXFormatterContext = createContext<
  TimeFormatter | undefined
>(undefined);

TimeseriesXFormatterContext['displayName'] = 'TimeseriesXFormatterContext';
